<div class="container-fluid">
  <div class="d-flex flex-wrap flex-row justify-content-start align-items-start mt-4">
    <div class="col-lg-2 order-0 ">
      <div>
        <app-menu-categoria></app-menu-categoria>
      </div>
      <br>
      <div class="no-movil">
        <app-tarjeta-carrusel></app-tarjeta-carrusel>
        <br>
        <app-oferta-pdfcarrusel *ngIf="isLoged()"></app-oferta-pdfcarrusel>
      </div>
    </div>
    <div class="col-lg-9 order-1 ml-5">
      <router-outlet></router-outlet>
    </div>
    <div class="col-lg-2 order-3 movil">
      <app-marcas-carrusel></app-marcas-carrusel>
      <br>
      <app-tarjeta-carrusel></app-tarjeta-carrusel>
      <br>
      <app-oferta-pdfcarrusel *ngIf="isLoged()"></app-oferta-pdfcarrusel>
    </div>
  </div>
</div>
